import PubSub from 'pubsub-js';
import { TOPIC_IDS } from '@/js/constants';
import { getUserAgent } from '@/js/utils/browser';

export default class DisableScroll {
  constructor () {
    this.state = {
      lastOffsetTop: 0,
      browser: getUserAgent().browser
    };
    this.scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    this.bind();
  }

  disable () {
    this.state.lastOffsetTop = window.scrollY;

    document.body.style.paddingRight = `${this.scrollBarWidth}px`;
    document.body.style.overflow = 'hidden';
    // below for Mobile Safari
    if (this.state.browser?.name === 'Mobile Safari') {
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    }
  }

  release () {
    document.body.style.top = '';
    if (this.state.browser?.name === 'Mobile Safari') {
      document.body.style.position = '';
      document.body.style.width = '';
    }
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    window.scrollTo(0, this.state.lastOffsetTop);

    this.state.lastOffsetTop = 0;
  }

  bind () {
    this.disable = this.disable.bind(this);
    this.release = this.release.bind(this);

    PubSub.subscribe(TOPIC_IDS.DISABLE_SCROLL_DISABLE, this.disable);
    PubSub.subscribe(TOPIC_IDS.DISABLE_SCROLL_RELEASE, this.release);
  }
}
